import { render, staticRenderFns } from "./show-error.vue?vue&type=template&id=97cb587a"
import script from "./show-error.vue?vue&type=script&lang=js"
export * from "./show-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97cb587a')) {
      api.createRecord('97cb587a', component.options)
    } else {
      api.reload('97cb587a', component.options)
    }
    module.hot.accept("./show-error.vue?vue&type=template&id=97cb587a", function () {
      api.rerender('97cb587a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/show-error.vue"
export default component.exports